import { action, makeObservable, observable } from 'mobx';

import { HomePageRootStore } from '../../index.store';
import { ConnectRootStore } from '../../utils/connectRootStore';

export enum LoginTab {
    Email,
    Phone,
}

export class ConsumerLoginStore extends ConnectRootStore<HomePageRootStore> {
    @observable public activeTab: LoginTab = LoginTab.Email;

    @observable public email = '';

    @observable public phone = '';

    @observable public root: HomePageRootStore;

    constructor(root: HomePageRootStore) {
        super(root);
        makeObservable(this);
    }

    @action
    public switchTab(tab: LoginTab) {
        this.activeTab = tab;
    }

    @action
    public setEmail(email: string) {
        this.email = email;
    }

    @action
    public setPhone(phone: string) {
        this.phone = phone;
    }

    @action
    public reset() {
        this.email = '';
        this.phone = '';
        this.activeTab = LoginTab.Email;
    }
}
